import Vue from 'vue'
import VueGtm from '@gtm-support/vue2-gtm'
import router from '../router'

const gtm = process.env.VUE_APP_GOOGLE_TAG_MANAGER
if (gtm) {
  Vue.use(VueGtm, {
    id: gtm,
    // debug: true,
    vueRouter: router
  })
}
